export default __webpack_public_path__ + "static/media/Madison.85fde098.png";